/* --- AVAILABILITY MODULE --- */
export const LOAD_RIDER_AVAILABILITY = "LOAD_RIDER_AVAILABILITY";
export const SAVE_RIDER_AVAILABILITY = "SAVE_RIDER_AVAILABILITY";
export const DELETE_RIDER_AVAILABILITY = "DELETE_RIDER_AVAILABILITY";
